import { useEffect, useState } from "react";
import { useNavigate, } from "react-router-dom";
import { LOCALSTORAGE } from "../Config";
import { supabase } from "../supabaseClient";
import { NFL_TEAMS, MLB_TEAMS, NBA_TEAMS } from "./teamLogos";

const getAllUsers = () => {
  const allUsersStr = localStorage.getItem(LOCALSTORAGE.USERS);
  let allUsers = JSON.parse(allUsersStr);
  if (allUsersStr === "" || allUsers == null) {
    allUsers = [];
  }
  return allUsers;
};

const updateBetTokens = (user) => {
  const oneDay = 24 * 60 * 60 * 1000; // milliseconds in a day
  const now = Date.now();
  const allUsers = JSON.parse(localStorage.getItem(LOCALSTORAGE.USERS));

  const userIndex = allUsers.findIndex((u) => u.email === user.email);
  if (userIndex !== -1) {
    allUsers[userIndex] = { ...allUsers[userIndex], ...user };
  }

  if (user.hasDonated) {
    user.betToken = "Unlimited";
  } else if (now - user.lastTokenUpdate > oneDay) {
    user.betToken = 3; // reset to 3 tokens every day
    user.lastTokenUpdate = now;
  }
};
const findUser = (username) => {
  const allUsers = getAllUsers();
  const foundUser = allUsers.find((user) => user.username === username);
  if (foundUser == null) {
    return null;
  } else {
    return foundUser;
  }
};
const findUserByEmail = (email) => {
  const allUsers = getAllUsers();
  const foundUser = allUsers.find((user) => user.email === email);
  if (foundUser == null) {
    return null;
  } else {
    return foundUser;
  }
};

const checkUserPassword = (userPassword, inputPassword) => {
  if (userPassword === inputPassword) {
    return true;
  } else {
    return false;
  }
};

const TeamDropdown = ({ teamSelect }) => {
  const [team, setTeam] = useState([]); // will hold objects { name, logo }
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [league, setLeague] = useState("NHL");
  const [leagueMenuOpen, setLeagueMenuOpen] = useState(false);
  const [teamMenuOpen, setTeamMenuOpen] = useState(false);

  useEffect(() => {
    const fetchTeam = async () => {
      try {
      if (league === "NHL") {
        const { data, error } = await supabase.functions.invoke("nhl-standings");
        if (error) throw error;

        const teamsArr = (data?.standings || []).map((team) => ({
          name: team.teamAbbrev?.default,
          logo: team.teamLogo,
        }));

        setTeam(teamsArr);
      } else if (league === "MLB") {
        setTeam(MLB_TEAMS);
      } else if (league === "NFL") {
        setTeam(NFL_TEAMS);
      } else if (league === "NBA") {
        setTeam(NBA_TEAMS);
      }
    } catch (err) {
      console.error("Failed to fetch teams:", err);
    }
  };

  fetchTeam();
}, [league]);

  const handleSelectedTeam = (teamObj) => {
    setSelectedTeam(teamObj);
    teamSelect(teamObj); // pass the whole object or just name/logo as needed
  };

  const handleLeagueChange = (newLeague) => {
    setLeague(newLeague);
    setSelectedTeam(null);
    setLeagueMenuOpen(false);
    setTeamMenuOpen(false);
  };

  return (
    <div className="team-picker">
      <div className="team-picker__inner">
        {/* League Selector */}
        <div className="team-picker__dropdown">
          <button
            className="fb-btn fb-btn--ghost team-picker__button"
            type="button"
            aria-expanded={leagueMenuOpen}
            onClick={() => setLeagueMenuOpen((prev) => !prev)}
          >
            {league ? league : "Select League"}
          </button>

          {leagueMenuOpen && (
            <div className="team-picker__menu">
              <button
                className="team-picker__item"
                type="button"
                onClick={() => handleLeagueChange("NHL")}
              >
                NHL
              </button>
              <button
                className="team-picker__item"
                type="button"
                onClick={() => handleLeagueChange("NFL")}
              >
                NFL
              </button>
              <button
                className="team-picker__item"
                type="button"
                onClick={() => handleLeagueChange("MLB")}
              >
                MLB
              </button>
              <button
                className="team-picker__item"
                type="button"
                onClick={() => handleLeagueChange("NBA")}
              >
                NBA
              </button>
            </div>
          )}
        </div>

        {/* Team Selector */}
        <div className="team-picker__dropdown">
          <button
            className="fb-btn fb-btn--ghost team-picker__button"
            type="button"
            aria-expanded={teamMenuOpen}
            onClick={() => setTeamMenuOpen((prev) => !prev)}
          >
            {selectedTeam ? (
              <span className="team-picker__selected">
                <img
                  src={selectedTeam.logo}
                  alt={selectedTeam.name}
                  style={{ width: "30px", height: "30px", marginRight: "10px" }}
                />
                {selectedTeam.name}
              </span>
            ) : (
              "Select Favorite Team"
            )}
          </button>

          {teamMenuOpen && (
            <div className="team-picker__menu">
              {team.map((teamObj, index) => (
                <div key={index}>
                  <button
                    className="team-picker__item team-picker__item--team"
                    type="button"
                    onClick={() => {
                      handleSelectedTeam(teamObj);
                      setTeamMenuOpen(false);
                    }}
                  >
                    <img
                      src={teamObj.logo}
                      alt={teamObj.name}
                      style={{ width: "30px", height: "30px", marginRight: "10px" }}
                    />
                    {teamObj.name}
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};


const RedirectBasedOnLogin = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const { data: sessionData, error } = await supabase.auth.getSession();

        if (error) {
          console.error("Error fetching session:", error);
          navigate("/");
          return;
        }

        if (sessionData?.session?.user) {
          setIsAuthenticated(true);
        } else {
          console.warn("No active session. Redirecting to /about.");
          navigate("/about");
        }
      } catch (err) {
        console.error("Error in authentication check:", err);
        navigate("/about");
      } finally {
        setLoading(false);
      }
    };

    checkAuthStatus();
  }, [navigate]);

  if (loading) return <div>Loading...</div>;

  return isAuthenticated ? <>{children}</> : null;
};

const ForgotPasswordPopup = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

const handleForgotPassword = async () => {
  try {
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: "https://friendly-bets.vercel.app/PasswordReset",
    });

    if (error) {
      console.error("Error sending reset email:", error);
      setMessage("There was an error sending the reset email. Please try again.");
    } else {
      setMessage("Password reset email sent! Check your inbox.");
    }
  } catch (err) {
    console.error("Unexpected error:", err);
    setMessage("Something went wrong. Please try again.");
  }
};

  

  return (
    <div className="modal show d-block" style={{ background: "rgba(0, 0, 0, 0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Forgot Password</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p>Enter your email to reset your password.</p>
            <input
              type="email"
              className="form-control mb-3"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
            />
            <button className="btn btn-primary" onClick={handleForgotPassword}>
              Send Reset Email
            </button>
            {message && <p className="mt-3">{message}</p>}
          </div>
        </div>
      </div>
    </div>
  );
};
export {
  getAllUsers,
  checkUserPassword,
  findUser,
  findUserByEmail,
  TeamDropdown,
  RedirectBasedOnLogin,
  updateBetTokens,
  ForgotPasswordPopup,

};
